<template><div><code-well-header>
  <example-tabs />
</code-well-header>
<h2 id="variants" tabindex="-1" class="d-docsite--header-2">Variants <a class="header-anchor d-link d-docsite--link d-link" href="#variants" aria-hidden="true">#</a></h2>
<h3 id="default" tabindex="-1" class="d-docsite--header-3">Default <a class="header-anchor d-link d-docsite--link d-link" href="#default" aria-hidden="true">#</a></h3>
<code-well-header>
  <example-tabs ref="defaultExample" />
</code-well-header>
<code-example-tabs
:htmlCode="() => $refs.defaultExample"
vueCode='
<dt-tab-group label="Label Example Group">
  <template #tabs>
    <dt-tab id="1" panel-id="2" selected>
      First tab
    </dt-tab>
    <dt-tab id="3" panel-id="4">
      Second tab
    </dt-tab>
    <dt-tab id="5" panel-id="6">
      Third tab
    </dt-tab>
  </template>
  <div>
    <dt-tab-panel id="2" tab-id="1">
      <p>First tab content panel</p>
    </dt-tab-panel>
    <dt-tab-panel id="4" tab-id="3">
      <p>Second tab content panel</p>
    </dt-tab-panel>
    <dt-tab-panel id="6" tab-id="5">
      <p>Third tab content panel</p>
    </dt-tab-panel>
  </div>
</dt-tab-group>
'
showHtmlWarning />
<h3 id="borderless" tabindex="-1" class="d-docsite--header-3">Borderless <a class="header-anchor d-link d-docsite--link d-link" href="#borderless" aria-hidden="true">#</a></h3>
<p class="d-docsite--paragraph">Add a <code v-pre>d-tablist--no-border</code> to remove the bottom border of any tablist. Handy for small tablists and tablists serving as subtabs to a larger menu.</p>
<code-well-header>
  <example-tabs borderless ref="borderlessExample" />
</code-well-header>
<code-example-tabs
:htmlCode="() => $refs.borderlessExample"
vueCode='
<dt-tab-group label="Label Example Group" :borderless="true">
  <template #tabs>
    <dt-tab id="1" panel-id="2" selected>
      First tab
    </dt-tab>
    <dt-tab id="3" panel-id="4">
      Second tab
    </dt-tab>
    <dt-tab id="5" panel-id="6">
      Third tab
    </dt-tab>
  </template>
  <div>
    <dt-tab-panel id="2" tab-id="1">
      <p>First tab content panel</p>
    </dt-tab-panel>
    <dt-tab-panel id="4" tab-id="3">
      <p>Second tab content panel</p>
    </dt-tab-panel>
    <dt-tab-panel id="6" tab-id="5">
      <p>Third tab content panel</p>
    </dt-tab-panel>
  </div>
</dt-tab-group>
'
showHtmlWarning />
<h3 id="inverted" tabindex="-1" class="d-docsite--header-3">Inverted <a class="header-anchor d-link d-docsite--link d-link" href="#inverted" aria-hidden="true">#</a></h3>
<p class="d-docsite--paragraph">Add <code v-pre>d-tablist--inverted</code> when you want to display tabs on inverted background.</p>
<code-well-header bgclass="d-bgc-contrast">
  <example-tabs inverted ref="invertedExample" />
</code-well-header>
<code-example-tabs
:htmlCode="() => $refs.invertedExample"
vueCode='
<dt-tab-group label="Label Example Group" :inverted="true">
  <template #tabs>
    <dt-tab id="1" panel-id="2" selected>
      First tab
    </dt-tab>
    <dt-tab id="3" panel-id="4">
      Second tab
    </dt-tab>
    <dt-tab id="5" panel-id="6">
      Third tab
    </dt-tab>
  </template>
  <div>
    <dt-tab-panel id="2" tab-id="1">
      <p>First tab content panel</p>
    </dt-tab-panel>
    <dt-tab-panel id="4" tab-id="3">
      <p>Second tab content panel</p>
    </dt-tab-panel>
    <dt-tab-panel id="6" tab-id="5">
      <p>Third tab content panel</p>
    </dt-tab-panel>
  </div>
</dt-tab-group>
'
showHtmlWarning />
<h3 id="disabled" tabindex="-1" class="d-docsite--header-3">Disabled <a class="header-anchor d-link d-docsite--link d-link" href="#disabled" aria-hidden="true">#</a></h3>
<code-well-header>
  <example-tabs disabled ref="disabledExample" />
</code-well-header>
<code-example-tabs
:htmlCode="() => $refs.disabledExample"
vueCode='
<dt-tab-group label="Label Example Group" :disabled="true">
  <template #tabs>
    <dt-tab id="1" panel-id="2" selected>
      First tab
    </dt-tab>
    <dt-tab id="3" panel-id="4">
      Second tab
    </dt-tab>
    <dt-tab id="5" panel-id="6">
      Third tab
    </dt-tab>
  </template>
  <div>
    <dt-tab-panel id="2" tab-id="1">
      <p>First tab content panel</p>
    </dt-tab-panel>
    <dt-tab-panel id="4" tab-id="3">
      <p>Second tab content panel</p>
    </dt-tab-panel>
    <dt-tab-panel id="6" tab-id="5">
      <p>Third tab content panel</p>
    </dt-tab-panel>
  </div>
</dt-tab-group>
'
/>
<h2 id="sizes" tabindex="-1" class="d-docsite--header-2">Sizes <a class="header-anchor d-link d-docsite--link d-link" href="#sizes" aria-hidden="true">#</a></h2>
<h3 id="default-1" tabindex="-1" class="d-docsite--header-3">Default <a class="header-anchor d-link d-docsite--link d-link" href="#default-1" aria-hidden="true">#</a></h3>
<code-well-header>
  <example-tabs ref="defaultSizeExample" />
</code-well-header>
<code-example-tabs
:htmlCode="() => $refs.defaultSizeExample"
vueCode='
<dt-tab-group label="Label Example Group">
  <template #tabs>
    <dt-tab id="1" panel-id="2" selected>
      First tab
    </dt-tab>
    <dt-tab id="3" panel-id="4">
      Second tab
    </dt-tab>
    <dt-tab id="5" panel-id="6">
      Third tab
    </dt-tab>
  </template>
  <div>
    <dt-tab-panel id="2" tab-id="1">
      <p>First tab content panel</p>
    </dt-tab-panel>
    <dt-tab-panel id="4" tab-id="3">
      <p>Second tab content panel</p>
    </dt-tab-panel>
    <dt-tab-panel id="6" tab-id="5">
      <p>Third tab content panel</p>
    </dt-tab-panel>
  </div>
</dt-tab-group>
'
showHtmlWarning />
<h3 id="small" tabindex="-1" class="d-docsite--header-3">Small <a class="header-anchor d-link d-docsite--link d-link" href="#small" aria-hidden="true">#</a></h3>
<code-well-header>
  <example-tabs size="sm" ref="smallExample" />
</code-well-header>
<code-example-tabs
:htmlCode="() => $refs.smallExample"
vueCode='
<dt-tab-group label="Label Example Group" size="sm">
  <template #tabs>
    <dt-tab id="1" panel-id="2" selected>
      First tab
    </dt-tab>
    <dt-tab id="3" panel-id="4">
      Second tab
    </dt-tab>
    <dt-tab id="5" panel-id="6">
      Third tab
    </dt-tab>
  </template>
  <div>
    <dt-tab-panel id="2" tab-id="1">
      <p>First tab content panel</p>
    </dt-tab-panel>
    <dt-tab-panel id="4" tab-id="3">
      <p>Second tab content panel</p>
    </dt-tab-panel>
    <dt-tab-panel id="6" tab-id="5">
      <p>Third tab content panel</p>
    </dt-tab-panel>
  </div>
</dt-tab-group>
'
showHtmlWarning />
<h2 id="advanced-usages" tabindex="-1" class="d-docsite--header-2">Advanced Usages <a class="header-anchor d-link d-docsite--link d-link" href="#advanced-usages" aria-hidden="true">#</a></h2>
<h3 id="validation-before-changing-tabs" tabindex="-1" class="d-docsite--header-3">Validation Before Changing Tabs <a class="header-anchor d-link d-docsite--link d-link" href="#validation-before-changing-tabs" aria-hidden="true">#</a></h3>
<p class="d-docsite--paragraph">If you need to do some validation before changing tabs, you can use the <code v-pre>before-change</code> event. If the event handler is prevented, the tab change will be cancelled.</p>
<code-well-header>
  <example-tabs validate ref="validationExample" />
</code-well-header>
<code-example-tabs
:htmlCode="() => $refs.validationExample"
vueCode='
<dt-tab-group
  label="Label Example Group"
  @before-change="confirmBeforeLeave"
>
  <template #tabs>
    <dt-tab id="1" panel-id="2" selected>
      First tab
    </dt-tab>
    <dt-tab id="3" panel-id="4">
      Second tab
    </dt-tab>
    <dt-tab id="5" panel-id="6">
      Third tab
    </dt-tab>
  </template>
  <div>
    <dt-tab-panel id="2" tab-id="1">
      <p>First tab content panel</p>
    </dt-tab-panel>
    <dt-tab-panel id="4" tab-id="3">
      <p>Second tab content panel</p>
    </dt-tab-panel>
    <dt-tab-panel id="6" tab-id="5">
      <p>Third tab content panel</p>
    </dt-tab-panel>
  </div>
</dt-tab-group>
<script setup>
  function confirmBeforeLeave (event) {
    const confirmed = confirm("Are you sure to change tab?");
    if (!confirmed) {
      event.preventDefault();
    }
  }
</script>
'
showHtmlWarning />
<h2 id="vue-api" tabindex="-1" class="d-docsite--header-2">Vue API <a class="header-anchor d-link d-docsite--link d-link" href="#vue-api" aria-hidden="true">#</a></h2>
<h3 id="tab-group" tabindex="-1" class="d-docsite--header-3">Tab Group <a class="header-anchor d-link d-docsite--link d-link" href="#tab-group" aria-hidden="true">#</a></h3>
<component-vue-api component-name="tabgroup" /><h3 id="tab-panel" tabindex="-1" class="d-docsite--header-3">Tab Panel <a class="header-anchor d-link d-docsite--link d-link" href="#tab-panel" aria-hidden="true">#</a></h3>
<component-vue-api component-name="tabpanel" /><h3 id="tab" tabindex="-1" class="d-docsite--header-3">Tab <a class="header-anchor d-link d-docsite--link d-link" href="#tab" aria-hidden="true">#</a></h3>
<component-vue-api component-name="tab" /><h2 id="classes" tabindex="-1" class="d-docsite--header-2">Classes <a class="header-anchor d-link d-docsite--link d-link" href="#classes" aria-hidden="true">#</a></h2>
<component-class-table component-name="tabs" /><h2 id="accessibility" tabindex="-1" class="d-docsite--header-2">Accessibility <a class="header-anchor d-link d-docsite--link d-link" href="#accessibility" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">To create accessible tabs, be sure to implement the <a class="d-link" href="https://www.w3.org/TR/wai-aria-practices-1.1/examples/tabs/tabs-2/tabs.html" target="_blank">proper keyboard navigation</a> and utilize the following ARIA roles to properly declare element roles, content relationships, and current status:</p>
<component-accessible-table component-name="tabs" /></div></template>


<script setup>
  import ExampleTabs from "@exampleComponents/ExampleTabs.vue";
</script>